import vtkSphereSource from '@kitware/vtk.js/Filters/Sources/SphereSource';
import vtkActor from '@kitware/vtk.js/Rendering/Core/Actor';
import vtkMapper from '@kitware/vtk.js/Rendering/Core/Mapper';

import { RGB, Vec3 } from '../../domain';

export class Sphere3DActor {
    private _actor: vtkActor | null = null;
    private _mapper: vtkMapper | null = null;
    private _sphereSource: vtkSphereSource | null = null;

    constructor() {
        const sphereSource = vtkSphereSource.newInstance({
            thetaResolution: 32,
            phiResolution: 32,
        });

        const mapper = vtkMapper.newInstance();
        mapper.setInputConnection(sphereSource.getOutputPort());

        const actor = vtkActor.newInstance();
        actor.setMapper(mapper);

        const props = actor.getProperty();
        props.setAmbient(0.3);
        props.setDiffuse(0.7);
        props.setSpecular(0.3);
        props.setSpecularPower(30);

        this._sphereSource = sphereSource;
        this._mapper = mapper;
        this._actor = actor;
    }

    get actor(): vtkActor {
        return this._actor!;
    }

    setRadius(radius: number): void {
        if (!this._sphereSource || !this._mapper) return;

        this._sphereSource.setRadius(radius);
    }

    setPosition(position: Vec3): void {
        if (!this._sphereSource || !this._mapper) return;

        this._sphereSource.setCenter(position[0], position[1], position[2]);
    }

    setColor(color: RGB): void {
        if (!this._actor) return;

        const props = this._actor.getProperty();
        props.setColor(color[0], color[1], color[2]);
    }

    setOpacity(opacity: number): void {
        if (!this._actor) return;

        const props = this._actor.getProperty();
        props.setOpacity(opacity);
    }

    dispose(): void {
        this._actor?.delete();
        this._mapper?.delete();
        this._sphereSource?.delete();

        this._sphereSource = null;
        this._mapper = null;
        this._actor = null;
    }
}
